const footLinks: { title: string; items: { label: string; href: string }[] }[] = [
  {
    title: "栏目导航",
    items: [
      { label: "今日瓜王", href: "#guanwang" },
      { label: "瓜田汇总", href: "#guatian" },
      { label: "本周大事", href: "#week" },
      { label: "热搜背后", href: "#shenbao" },
    ],
  },
  {
    title: "参与互动",
    items: [
      { label: "瓜友讨论区", href: "#discuss" },
      { label: "吃瓜问答", href: "#faq" },
      { label: "订阅瓜讯", href: "#top" },
      { label: "我要投稿", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300 text-foreground-800">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center text-background-50 font-label text-lg">瓜</span>
              <span className="font-heading font-bold text-xl text-foreground-950">每日吃瓜</span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              每日吃瓜，全网热瓜一网打尽。今日瓜田汇总、本周大事件盘点、热搜背后故事、营销号没敢说的，陪吃瓜群众理性追更每一天。
            </p>
            <p className="mt-4 text-sm text-foreground-600">联系邮箱：<a href="mailto:hello@meirichigua.com" className="text-primary-700 hover:underline">hello@meirichigua.com</a></p>
          </div>
          {footLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading font-bold text-foreground-950 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.items.map((it) => (
                  <li key={it.label}>
                    <a href={it.href} className="text-sm text-foreground-600 hover:text-primary-700 transition-colors">{it.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© {new Date().getFullYear()} 每日吃瓜 Meirichigua · 理性吃瓜，尊重事实</p>
          <p className="flex items-center gap-4">
            <a href="#top" className="hover:text-primary-700">隐私说明</a>
            <a href="#top" className="hover:text-primary-700">免责声明</a>
            <a href="#top" className="hover:text-primary-700">联系合作</a>
          </p>
        </div>
      </div>
    </footer>
  );
}